module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_24-652dfbaadf876f998535aa5b0d63cb73.jpg";